import React from 'react';
import Layout from '../../components/UI/Layout/Layout'
import List from '../../components/Entity/Parser/List/List';

const Parser = () => {
  return <Layout fullwidth={0}>
      <List></List>
  </Layout>;
}

export default Parser;
